import { typeCheckAppModule } from "src/utils";
import { NAME } from "./constants";
import { Products } from "./Products";

export const productList = typeCheckAppModule({
    NAME,
    Container: Products,
});
